import React, {useEffect, useState} from 'react';

// import { useModalUpdate } from "../../components/context/ModalContext";
import { useVideoModalUpdate, useVideoIDUpdate } from "../../components/context/ModalContext";
import { useDataUpdate } from "../../components/context/DataContext";
import { useCookies } from 'react-cookie';

import Button from '../../components/Buttons/Button';
import cirleImg from "../../assets/images/center-circle.png";
import cirleImgTab from "../../assets/images/center-circle-tab.png";

import { gaMenuButtonClick } from '../../utils/gatags';

import './Content.css';
import Footer from '../Footer/Footer';

const Content = () => {

    const setDataState = useDataUpdate();
    const [data, setData] = useState(null);
    const [cookies, setCookie] = useCookies(['vidProgress']);
    const [progressArray, setProgressArray] = useState([0,0,0,0,0,0,0,0]);

    const videoModalSet = useVideoModalUpdate(true);
    const videoIDSet = useVideoIDUpdate(0);





    const setModalContent = (_sec) => {
        videoIDSet(_sec)
        videoModalSet(true);
        gaCapture(_sec);
        progressArray[_sec] = 1;
        // console.log(progressArray);
        // updateCookie();
        setProgress();
    }

    const gaCapture = (_idx) => {
        const modalEl = document.getElementsByClassName("btn" + _idx);
        gaMenuButtonClick(modalEl[0].classList[1], modalEl[0].innerText.replace(/(\r\r|\n\n)/gm, " - "));
    }

    useEffect(() => {
        fetch('./content.json'
    ,{
      headers : { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
       }
    }
    )
    .then(function(response){
        return response.json();
    })
    .then(function(dataJson) {
        setData(dataJson);
        setDataState(dataJson);
        const expires = Math.floor(Date.now() / 1000);
        if ( !cookies.vidProgress ) {
            setCookie("vidProgress", '00000000', {
                path: '/',
                expires: getExpireDate()
            })
        } else {
            const _cookies = cookies.vidProgress;
            const _progressArray = Array.from(String(_cookies), Number);
            _progressArray.forEach((char, _index) => {
                progressArray[_index] = _progressArray[_index]
            });
            
        }
    });
    }, []) 

   const getExpireDate = () => {

        const date = new Date();
        // Default at 365 days.
        const days = 365;
        // Get unix milliseconds at current time plus number of days
        date.setTime(+ date + (days * 86400000)); //24 * 60 * 60 * 1000


        // // Get the current date
        // var currentDate = new Date();
        // // Calculate the milliseconds in two weeks
        // var twoWeeksInMillis = 14 * 24 * 60 * 60 * 1000;
        // // Add two weeks to the current date
        // var futureDate = new Date(currentDate.getTime() + twoWeeksInMillis);
        // // Output the future date
        // console.log(futureDate);





        // // Get the current date and time
        // var currentDate = new Date();
        // // Add 1 minute (60 seconds) to the current time
        // currentDate.setTime(currentDate.getTime() + (1 * 60 * 1000));
        // // Display the new date and time
        // console.log(currentDate);


        return date;
    }
    const setProgress = () => {
        const _cookies = cookies.vidProgress;
        const arrStr = progressArray.join();
        console.log("set cookie");
        setCookie("vidProgress", arrStr.replace(/,/g, ""), {
            path: '/',
            expires: getExpireDate()
        })
        // document.cookie = "username=John Smith; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/";
    }

    if (!data) {
        return (
            <div className="loading-elem">
                <p>Loading data...</p>;
            </div>
        )
    }

    return (
        <div className="App">
            <div id="component-574623">
                <div className="content">
                    <div className="mobile-header">
                        <h1>BIOSIMILARS: BASICS AND BEYOND</h1>
                    </div>
                    <div className="tab">
                        <div className="tab-circle">
                            <img src={cirleImgTab} alt="Center circle" />
                            <div className='center-text'>BIOSIMILARS: <span className="adaptive-break"><br /></span>BASICS AND <span className="adaptive-break"><br /></span>BEYOND</div>
                        </div>
                        <div className="container">
                            <div className="child">
                                <Button id="0" clickitem={setModalContent} active={progressArray[0]} />
                                <Button id="1" clickitem={setModalContent} active={progressArray[1]} />
                                <Button id="2" clickitem={setModalContent} active={progressArray[2]} />
                                <Button id="3" clickitem={setModalContent} active={progressArray[3]} />
                            </div>
                            <div className="child circle-wrap">
                                <div className="circle">
                                    <img src={cirleImg} alt="Center circle" />
                                    <div className='center-text'>BIOSIMILARS: <span className="adaptive-break"><br /></span>BASICS AND <span className="adaptive-break"><br /></span>BEYOND</div>
                                </div>
                            </div>
                            <div className="child">
                                <Button id="4" clickitem={setModalContent} active={progressArray[4]} />
                                <Button id="5" clickitem={setModalContent} active={progressArray[5]} />
                                <Button id="6" clickitem={setModalContent} active={progressArray[6]} />
                                <Button id="7" clickitem={setModalContent} active={progressArray[7]} />
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
        );
    };
    
    export default Content;